<template>
    <div v-show="options.isAlert" class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{options.modalTitle}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalEvent('close')">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p v-html="urlifyModalText"></p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="onModalEvent('confirm')">{{'Confirm' | translate}}</button>
                </div>
                </div>
            </div>
        </div>
</template>
<script>
export default {
    props:{
        options:{
            isAlert:false,
            modalTitle:'Title',
            modalText:'Text',
        }
    },
    methods:{
        onModalEvent(value){
            this.$emit('modalEvent',value)
        }
    },
    computed:{
        urlifyModalText() {
            var urlRegex = /(https?:\/\/[^\s]+)/g
                return this.options.modalText.replace(urlRegex, function(url) {
                    return '<a href="' + url + '" target="_blank">' + url + '</a>'
                })
            
        }
    }
    
}
</script>
<style>
.modal {
    display:block;
    white-space:pre-wrap;
    word-wrap: break-word;
}
</style>

